import React, { useState, useEffect, useContext } from "react";
import LineDetails from "./component/LineDetails";
import MainLayout from "../../common/layout/MainLayout";
import { TableCell, TableRow } from "@mui/material";
import PlanDetails from "./component/PlanDetails";
import Loading from "../loading/Loading";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";
// import routeConstant from "../../routes/utils/routeConstant";
import DownloadIcon from "@mui/icons-material/Download";
import TableScrollDiv from "../../common/component/table/TableScrollDiv";
import "./index.css";
import instance from "../../common/api/interceptor";
import { path } from "../../constants/apiPath";
import { StoreContext } from "../../store";
import { StoreContext as StoreContextTwo } from "../../../store/Provider";
import Button from "@mui/material/Button";
import routeConstant from "../../../route/compoent/routeConstant";

function Details() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState({});
  const context = useContext(StoreContext);
  const contextTwo = useContext(StoreContextTwo);
  const [hoverLoad, setHoverLoad] = useState(false);
  const [hoverData, setHoverData] = useState([]);

  // useEffect(() => {
  //   console.log("CardData:",cardData.OrderMilstonesCollection[2].MilstoneActualDate)
  // }, [cardData])
  

  const docOrderColumn = [
    "Sr. No",
    "Doc Type",
    "Doc Name",
    "Doc Size",
    "Uploaded On",
    "Uploaded By",
    "Download",
  ];

  useEffect(() => {
    setLoading(true);
    if (location?.state) {
      if (Object.keys(location?.state)?.length) {
        setCardData(location.state);
        setLoading(false);
      } else {
        navigate(routeConstant.ORDER_LIST);
        NotificationManager.error("No order details found", "", 3000);
        setLoading(false);
      }
    } else {
      navigate(routeConstant.ORDER_LIST);
      NotificationManager.error("No order details found", "", 3000);
      setLoading(false);
    }
  }, []);

  const onDocumentDownload = (ele) => {
    // cardData?.OrderHeader?.OrderPK ?? ""
    context.setBackDropOpen(true);
    if (ele.DocsPk) {
      const url = `${path.DOWNLOAD_DOCUMENTS}?orderPK=${ele.DocsFk}&documentPK=${ele.DocsPk}`;
      instance
        .get(url)
        .then((res) => {
          if (res.Is_Success) {
            const a = document.createElement("a");

            a.href = `${res.data.DocsFileConversion}${res.data.DocsFileData}`;
            a.target = "_blank";
            a.download = res.data.DocsFileName;
            a.name = res.data.DocsFileName ?? "document";
            a.click();

            context.setBackDropOpen(false);
            NotificationManager.success(res.Message, "", 3000);
          } else {
            context.setBackDropOpen(false);
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          context.setBackDropOpen(false);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      const a = document.createElement("a");
      a.href = `${ele.DocsFileConversion}${ele.DocsFileData}`;
      a.target = "_blank";
      a.download = ele.DocsFileName;
      a.name = ele.DocsFileName;
    }
  };

  const getOrderBasedOnContainer = (number) => {
    setHoverLoad(true);
    setHoverData([]);
    instance
      .get(`${path.GET_ORDER_BASED_ON_CONTAINER}?cotainerNumber=${number}`)
      .then((res) => {
        setHoverLoad(false);
        setHoverData(res.data ?? []);
        console.log(res);
      })
      .catch((err) => {
        setHoverLoad(false);
        setHoverData([]);
        console.log(err);
      });
  };

  const createShipment = (orderPk) => {
    context.setBackDropOpen(true);

    instance
      .post(`${path.CREATE_SHIPMENT_CARGOWISE}?orderPk=${orderPk}`)
      .then((res) => {
        if (res.Is_Success) {
          const data = JSON.parse(JSON.stringify(cardData));
          console.log('Card Data', data);
          data.OrderHeader.IsShipmentCreated = "1";

          setCardData({ ...data });

          NotificationManager.success(res.Message, "", 3000);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  const showLogDetails = () => {
    if (location.pathname.includes(routeConstant.ORDER_LIST)) {
      navigate(routeConstant.ORDER_LIST_FULL_LOG, {
        state: {
          OrderPK: cardData.OrderHeader?.OrderPK,
        },
      });
    } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
      navigate(routeConstant.DASH_ORDER_LIST_FULL_LOG, {
        state: {
          OrderPK: cardData.OrderHeader?.OrderPK,
        },
      });
    }
  };

  // const getMilestoneDate = milestones => {

  //   if (!milestones || milestones.length < 3) {
  //     return '';
  //   }
  
  //   const estimatedDate = milestones[2]?.MilstoneEstimatedDate;
  //   const actualDate = milestones[2]?.MilstoneActualDate;
  
  //   if (estimatedDate === "1900-01-01 00:00:00.000") {
  //     return '';
  //   }
  
  //   if (actualDate) {
  //     return moment(actualDate).format("MM-DD-YYYY");
  //   }
  
  //   if (estimatedDate) {
  //     return moment(estimatedDate).format("MM-DD-YYYY");
  //   }
  
  //   return '';
  // };

  return (
    // <MainLayout>
    <div className="_orderListFullDetailsComponent">
      {loading ? (
        <Loading />
      ) : (
        <div className="container-fluid">
          <div className="row _orderListFullDetailsOrderSpecific">
            <div className="col-12 _orderListFullDetailsOrderSpecificDetails">
              <div className="_orderHeaderdetail">
                <h5>Order Specifics</h5>
                <div className="_orderHeaderdetailAction">
                  {/* {cardData?.OrderHeader?.OrderStatus === "SHP" &&
                    context.orderUserAccess?.CreateShipment && (
                      <Button
                        disabled={
                          cardData.OrderHeader?.IsShipmentCreated === "1"
                            ? true
                            : false
                        }
                        onClick={() => {
                          createShipment(cardData.OrderHeader?.OrderPK);
                        }}
                        className="_orderHeaderdetailActionButton"
                        variant="contained"
                      >
                        Create Shipment in CW
                      </Button>
                    )} */}
                  {/* context.orderUserAccess?.ShowSubOrder && */}
                  {contextTwo.omsUserData?.UserRoles.includes("Admin") &&
                  cardData?.OrderHeader?.OrderType !== "SUB" &&
                  cardData?.OrderHeader?.OrderStatus !== "ARC" &&
                  cardData?.OrderHeader?.OrderStatus !== "CAN" ? (
                    <Button
                      onClick={() => {
                        contextTwo.setNotificationOpen({
                          open: true,
                          type: "MergeOrder",
                          orderPk: cardData?.OrderHeader
                            ? cardData?.OrderHeader?.OrderPK
                            : "",
                          reload: false,
                        });
                      }}
                      variant="contained"
                      className="_orderHeaderdetailActionButton _orderDetailsViewLog"
                    >
                      Merge Order
                    </Button>
                  ) : null}
                  <Button
                    onClick={showLogDetails}
                    variant="contained"
                    className="_orderHeaderdetailActionButton _orderDetailsViewLog"
                  >
                    View Log
                  </Button>
                </div>
              </div>

              <div className="row">
                <div className="col-12 _orderListFullDetailsComponentTableDiv">
                  <table>
                    <tbody>
                      <tr>
                        <th>Order Number</th>
                        <th>:</th>
                        <td
                          title={
                            cardData?.OrderHeader?.SplitNumber == "0"
                              ? `${cardData?.OrderHeader?.OrderNumber}`
                              : `${cardData?.OrderHeader?.OrderNumber}/${cardData?.OrderHeader?.SplitNumber}`
                          }
                        >
                          {cardData?.OrderHeader?.OrderNumber}
                          {cardData?.OrderHeader?.SplitNumber !== "0"
                            ? `/${cardData?.OrderHeader?.SplitNumber}`
                            : ""}
                        </td>
                        <th>Order Date</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderDate ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : cardData?.OrderHeader?.OrderDate
                            ? moment(cardData?.OrderHeader?.OrderDate).format(
                                "MM-DD-YYYY"
                              )
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>CW1 Order Number</th>
                        <th>:</th>
                        <td></td>
                        <th>Order Status</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderStatus}</td>
                      </tr>
                      <tr>
                        <th>Sending Agent</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderSendingAgentCode}</td>
                        <th>Receiving Agent</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderReceivingAgentCode}
                        </td>
                      </tr>
                      <tr>
                        <th>Supplier Name</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderSupplierCode ?? ""}
                        </td>
                        <th>Supplier Address</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderSupplierAddress1 ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Buyer Name</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderBuyerCode ?? ""}</td>
                        <th>Buyer Address</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderBuyerAddress1 ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Final Delivery Location</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderBuyerDeliveryAddress1 ??
                            ""}
                        </td>
                        <th>Special Instructions</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderSpecialInstruction}
                        </td>
                      </tr>
                      <tr>
                        <th>Currency of Payment</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderCurrencyCode ?? ""}
                        </td>
                        <th>INCO Terms</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderIncoTerm ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Container Mode</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderContainerMode ?? ""}
                        </td>
                        <th>Transport Mode</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderTransportMode ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Req. Ex. Works</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderExWorksRequiredBy ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : cardData?.OrderHeader?.OrderExWorksRequiredBy
                            ? moment(
                                cardData?.OrderHeader?.OrderExWorksRequiredBy
                              ).format("MM-DD-YYYY")
                            : ""}
                        </td>
                        <th>Req. In Store</th>
                        <th>:</th>
                        <td>
                          {cardData?.OrderHeader?.OrderDeliveryRequiredBy ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : cardData?.OrderHeader?.OrderDeliveryRequiredBy
                            ? moment(
                                cardData?.OrderHeader?.OrderDeliveryRequiredBy
                              ).format("MM-DD-YYYY")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Service Level</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderServiceLevelcode}</td>
                        <th>Shipment No.</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderPreAdviceId}</td>
                      </tr>
                      <tr>
                        <th>Invoice No.</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderInvoiceNumber}</td>
                        <th>Origin Country</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderCountryOfOrigin}</td>
                      </tr>
                      <tr>
                        <th>Goods Description</th>
                        <th>:</th>
                        <td>{cardData?.OrderHeader?.OrderGoodsDescription}</td>
                         <th>Pickup from Origin Factory </th>
                        <th>:</th>
                        <td>
                        {/* {getMilestoneDate(cardData?.OrderMilstonesCollection)} */}
                        {cardData?.OrderHeader?.PickupfromOriginFactory ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : cardData?.OrderHeader?.PickupfromOriginFactory
                            ? moment(cardData?.OrderHeader?.PickupfromOriginFactory).format(
                                "MM-DD-YYYY"
                              )
                            : ""}
                        </td> 
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row _orderListFullDetailsOrderLine">
            <div className="col-12">
              <h5>ORDER LINE</h5>
              <LineDetails lineData={cardData?.OrderLinesCollection ?? []} />
            </div>
          </div>
          <div className="row _orderListFullDetailsOrderPlan">
            <div className="col-12 _orderListFullDetailsOrderPlanHeading">
              <h5>ORDER PLAN</h5>
            </div>
            <div className="col-12">
              <PlanDetails
                tranportMode={cardData?.OrderHeader?.OrderTransportMode ?? ""}
                orderPlan={cardData?.OrderPlanningCollection ?? []}
                getOrderBasedOnContainer={getOrderBasedOnContainer}
                hoverLoad={hoverLoad}
                hoverData={hoverData}
              />
            </div>
          </div>
          <div className="row _orderListFullDetailsDocsUpload">
            <div className="col-12">
              <h5>E-DOCS</h5>
              <TableScrollDiv
                className=" _orderListFullDetailsDocsUploadTable"
                column={docOrderColumn}
              >
                {cardData?.OrderDocumentsCollection?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7}>No Doc Uploaded</TableCell>
                  </TableRow>
                ) : (
                  cardData?.OrderDocumentsCollection?.map((ele, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{ele?.DocsDocType}</TableCell>
                        <TableCell>{ele?.DocsFileName}</TableCell>
                        <TableCell>{`${ele?.DocsFileSize} ${ele?.DocsFileSizeUnit}`}</TableCell>
                        <TableCell>
                          {ele?.DocsUploadedDate.split(" ")[0]}
                        </TableCell>
                        <TableCell>{ele?.DocsUploadedBY}</TableCell>
                        <TableCell>
                          <a
                            // className="_orderlineDocDownloadAnchor"
                            // href={`${ele.DocsFileConversion}${ele.DocsFileData}`}
                            // target={"_blank"}
                            // download={ele.DocsFileName}
                            // name={ele.DocsFileName}
                            onClick={() => {
                              onDocumentDownload(ele);
                            }}
                          >
                            <DownloadIcon />
                          </a>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableScrollDiv>
            </div>
          </div>
        </div>
      )}
    </div>
    // </MainLayout>
  );
}

export default Details;
